// extracted by mini-css-extract-plugin
export default {"appName":"Apps_appName__KMJ50","title":"Apps_title__XlBEG","package":"Apps_package__pF-K5","icon":"Apps_icon__63EHB","picker":"Apps_picker__sHzy-"};